export class BalanceCard {
  constructor(
    public updateDate: string | Date,
    public balance: number,
    public variationPercentage: number,
    public accountNumber?: string
  ) {}
}
